var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.searching
      ? _c(
          "div",
          [
            _c("search-screen", {
              attrs: { type: _vm.tp },
              on: { "screen-click": _vm.toggleMode, change: _vm.changeType }
            }),
            _vm._v(" "),
            _c("rg-toolbar-search", {
              attrs: { focused: true },
              on: { back: _vm.toggleMode, search: _vm.search }
            })
          ],
          1
        )
      : _c("div", { staticClass: "ui top fixed menu borderless" }, [
          _c(
            "button",
            {
              staticClass: "item icon",
              class: _vm.$style.itemBtn,
              attrs: { "data-wd": "sideToggler" },
              on: {
                click: function($event) {
                  return _vm.$store.dispatch("toggle")
                }
              }
            },
            [
              _c("i", {
                directives: [
                  {
                    name: "new-feature",
                    rawName: "v-new-feature",
                    value: _vm.user ? { id: "notelists", target: null } : {},
                    expression: "user ? { id: 'notelists', target: null } : {}"
                  }
                ],
                staticClass: "content icon"
              })
            ]
          ),
          _vm._v(" "),
          _c("div", { class: _vm.$style.titleCont }, [
            _c("h2", { class: _vm.$style.title }, [
              _vm._v("\n        " + _vm._s(_vm.resultTitle) + "\n      ")
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.$route.name !== "home",
                  expression: "$route.name !== 'home'"
                }
              ],
              staticClass: "right menu"
            },
            [
              _c(
                "button",
                {
                  staticClass: "item icon",
                  class: _vm.$style.itemBtn,
                  attrs: { "data-wd": "inSearchToggler" },
                  on: { click: _vm.toggleMode }
                },
                [_c("i", { staticClass: "search icon" })]
              )
            ]
          )
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }